import BannerRowItem from '~/shared/components/items-navigator/components/banner-row-item/banner-row-item';
import CourseRowItem from '~/shared/components/items-navigator/components/course-row-item/course-row-item';
import ExtendedRowItem from '~/shared/components/items-navigator/components/extended-row-item/extended-row-item';
import { LIST_ITEM_TYPE } from '~/shared/constants';
import type { CourseType } from '~/shared/types/course-type';
import type { ItemDataType } from '~/shared/types/general-type';

const getRowItems = ({
  items,
  pageToGo,
  lng,
  pageTagsToGo,
  t,
  isMobile,
  itemType,
}: {
  isMobile: boolean;
  items: ItemDataType[];
  itemType: string;
  pageToGo: string;
  pageTagsToGo?: string;
  t: (key: string, options: { ns: string[] }) => string;
}) =>
  items?.map((itemData: ItemDataType) => {
    switch (itemType) {
      case LIST_ITEM_TYPE.EXTENDED:
        return (
          <ExtendedRowItem
            key={itemData._id}
            lng={lng}
            pageToGo={pageToGo}
            pageTagsToGo={pageTagsToGo}
            data={itemData}
            t={t}
          />
        );
      case LIST_ITEM_TYPE.BANNER:
        return (
          <BannerRowItem
            isMobile={isMobile}
            key={itemData._id}
            lng={lng}
            pageTagsToGo={pageTagsToGo}
            data={itemData as unknown as CourseType}
            pageToGo={pageToGo}
            t={t}
          />
        );
      case LIST_ITEM_TYPE.COURSE:
        return <CourseRowItem key={itemData?.data?._id} lng={lng} data={itemData as unknown as CourseType} t={t} />;
      default:
        return (
          <ExtendedRowItem
            key={itemData._id}
            lng={lng}
            data={itemData}
            pageTagsToGo={pageTagsToGo}
            pageToGo={pageToGo}
            t={t}
          />
        );
    }
  });

export default getRowItems;
